import useFaqT from "./useFaqT";

// Role bar (design F3): the "Viewing as …" chip, resolved from the REAL
// role/permission state — never a user choice — plus a one-line note.
//
// WHAT LEFT THIS BAR ON 2026-08-10 AND WHY
// ----------------------------------------
// It used to carry a two-state "Show all questions" toggle: the role filter was
// declared a RELEVANCE filter, foreign rows were revealed on demand and marked
// with a pill ("filtered, never hidden"). Marin ended that: "für andere rollen
// darfst du nicht anzeigen, der Agent und Agency darf sicher nicht wissen was
// alles die Clubs haben!" The role split is a CONFIDENTIALITY boundary now — a
// viewer receives only the questions of their own tiers, and there is no control
// that could cross into another branch, because the other branches never reach
// the client at all (constants/faq/faqBranchData.js). A toggle here would have
// been the one visible promise that the boundary is negotiable.
//
// Mobile (<md): the chip wraps rather than truncating; the note is hidden
// (design F7).
const FaqRoleBar = ({ roleLabel }) => {
  const tr = useFaqT();
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-[#EDEEF0] bg-[#FAFBFC] px-4 py-3 md:gap-x-5 md:px-10 md:py-5 xl:px-[72px]">
      <div className="flex min-w-0 flex-wrap items-center gap-2.5 text-[13px] text-[#5A626E]">
        {/* max-w-full + the wrapping inner span: the chip is the only element
            left in this row, and a long translated dual-role label ("Viewing as
            Agency admin · Lawyer" in German) must WRAP at 375px, never push the
            row into a horizontal scroll. `flex-none` alone would have sized it
            to its content and overflowed. */}
        <span className="inline-flex max-w-full flex-none items-start gap-1.5 border border-[#D3DEFF] bg-[#EEF2FF] px-[9px] py-[5px] text-[12px] font-medium text-[#1543C6]">
          <span aria-hidden="true" className="mt-[5px] h-1.5 w-1.5 flex-none rounded-full bg-[#1F5EFF]" />
          <span className="min-w-0 break-words">
            {/* The label comes from faqRoles.js as an EN source string ("Club
                admin", or "Agent · Lawyer" for a dual role). i18next does NOT
                translate interpolation VALUES, so passing it straight through
                left the one word that names the reader in English in all 15
                other languages ("Ansicht als Club admin" — control pass F-3).
                Each part is translated on its own; the separator is layout, not
                copy, so it stays out of the key. */}
            {tr("Viewing as {{role}}", {
              role: String(roleLabel || "")
                .split(" · ")
                .map((part) => tr(part))
                .join(" · "),
            })}
          </span>
        </span>
        <span className="hidden md:inline">{tr("Questions for your role.")}</span>
      </div>
    </div>
  );
};

export default FaqRoleBar;
